import 'babel-polyfill'
import polyfill from 'dynamic-polyfill'

polyfill({
  fills: ['Array.from', 'fetch', 'Promise', 'Object.assign', 'Object.entries', 'String.prototype.includes', 'Number.isNaN'],
  options: ['gated'],
  afterFill() {
    require('./main.js')
  }
})
